import React from 'react';
import { formatTime } from './helpers/cellFormatters';

const Time = ({ params }) => {
    const value = params?.value;

    if (value == null || value === '') {
        return <></>;
    }

    return <span>{formatTime(value)}</span>;
};

export default Time;
